export default {

  formatterDate (data, fmt) {
    if (!data) {
      return ''
    }
    data = new Date(data)
    let o = {
      'M+': data.getMonth() + 1, // 月份
      'd+': data.getDate(), // 日
      'h+': data.getHours() % 12 === 0 ? 12 : data.getHours() % 12, // 小时
      'H+': data.getHours(), // 小时
      'm+': data.getMinutes(), // 分
      's+': data.getSeconds(), // 秒
      'q+': Math.floor((data.getMonth() + 3) / 3), // 季度
      'S': data.getMilliseconds() // 毫秒
    }
    let week = {
      '0': '/u65e5',
      '1': '/u4e00',
      '2': '/u4e8c',
      '3': '/u4e09',
      '4': '/u56db',
      '5': '/u4e94',
      '6': '/u516d'
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (data.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    if (/(E+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? '/u661f/u671f' : '/u5468') : '') + week[data.getDay() + ''])
    }
    for (let k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return fmt
  },
  dateJl (start, end) {
    let i = end.getTime() - start.getTime()
    let a = parseInt(i / (60 * 60 * 1000))
    if (a < 1) {
      return '刚刚'
    } else {
      // let a = Number(this.formatterDate(start, 'yyyyMMddHH'))
      // let b = Number(this.formatterDate(end, 'yyyyMMddHH'))
      if (a < 24) {
        return `${a}小时前`
      } else {
        a = parseInt(a / 24)
        return `${a}天前`
      }
    }
  },
  CurrencyFormatted (amount) {
    let i = parseFloat(amount)
    if (isNaN(i)) {
      i = 0.00
    }
    let minus = ''
    if (i < 0) {
      minus = '-'
    }
    i = Math.abs(i)
    i = parseInt((i + 0.005) * 100)
    i = i / 100
    let s = i + ''
    if (s.indexOf('.') < 0) {
      s += '.00'
    }
    if (s.indexOf('.') === (s.length - 2)) {
      s += '0'
    }
    s = minus + s
    return s
  },
  wgs84togcj02 (lng, lat) {
    // var x_PI = 3.14159265358979324 * 3000.0 / 180.0
    var PI = 3.1415926535897932384626
    var a = 6378245.0
    var ee = 0.00669342162296594323
    if (this.out_of_china(lng, lat)) {
      return [lng, lat]
    } else {
      var dlat = this.transformlat(lng - 105.0, lat - 35.0)
      var dlng = this.transformlng(lng - 105.0, lat - 35.0)
      var radlat = lat / 180.0 * PI
      var magic = Math.sin(radlat)
      magic = 1 - ee * magic * magic
      var sqrtmagic = Math.sqrt(magic)
      dlat = (dlat * 180.0) / ((a * (1 - ee)) / (magic * sqrtmagic) * PI)
      dlng = (dlng * 180.0) / (a / sqrtmagic * Math.cos(radlat) * PI)
      var mglat = lat + dlat
      var mglng = lng + dlng
      return [mglng, mglat]
    }
  },
  out_of_china (lng, lat) {
    // 纬度3.86~53.55,经度73.66~135.05
    return !(lng > 73.66 && lng < 135.05 && lat > 3.86 && lat < 53.55)
  },
  transformlat (lng, lat) {
    var PI = 3.1415926535897932384626
    var ret = -100.0 + 2.0 * lng + 3.0 * lat + 0.2 * lat * lat + 0.1 * lng * lat + 0.2 * Math.sqrt(Math.abs(lng))
    ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0
    ret += (20.0 * Math.sin(lat * PI) + 40.0 * Math.sin(lat / 3.0 * PI)) * 2.0 / 3.0
    ret += (160.0 * Math.sin(lat / 12.0 * PI) + 320 * Math.sin(lat * PI / 30.0)) * 2.0 / 3.0
    return ret
  },
  transformlng (lng, lat) {
    var PI = 3.1415926535897932384626
    var ret = 300.0 + lng + 2.0 * lat + 0.1 * lng * lng + 0.1 * lng * lat + 0.1 * Math.sqrt(Math.abs(lng))
    ret += (20.0 * Math.sin(6.0 * lng * PI) + 20.0 * Math.sin(2.0 * lng * PI)) * 2.0 / 3.0
    ret += (20.0 * Math.sin(lng * PI) + 40.0 * Math.sin(lng / 3.0 * PI)) * 2.0 / 3.0
    ret += (150.0 * Math.sin(lng / 12.0 * PI) + 300.0 * Math.sin(lng / 30.0 * PI)) * 2.0 / 3.0
    return ret
  },
  bd09togcj02 (bdlon, bdlat) {
    var xPI = 3.14159265358979324 * 3000.0 / 180.0
    var x = bdlon - 0.0065
    var y = bdlat - 0.006
    var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * xPI)
    var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * xPI)
    var gglng = z * Math.cos(theta)
    var gglat = z * Math.sin(theta)
    return [gglng, gglat]
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/utils.js